const guiColors = {
    'color-scheme': 'dark',

    'ui-primary': '#030303',
    'ui-secondary': '#080808',
    'ui-tertiary': 'var(--looks-secondary-darker)',

    'ui-modal-overlay': '#060606aa',
    'ui-modal-background': '#030303',
    'ui-modal-foreground': 'white',
    'ui-modal-header-background': 'var(--looks-secondary-darker)',
    'ui-modal-header-foreground': '#ffffff',

    'ui-white': '#030303',

    'ui-black-transparent': '#ffffff26',

    'text-primary': '#eeeeee',

    'assets-background': '#030303',

    'input-background': '#050505',

    'popover-background': '#050505',

    'badge-background': '#16202c',
    'badge-border': '#203652',
	
	'menu-bar-background': 'var(--looks-secondary-darker)',
    'menu-bar-foreground': 'white',
    'menu-bar-background-image': 'none',
	'menu-bar-icon-filter': 'none',
	
	'progress-bar-outer': 'var(--looks-secondary-darker)',

    'fullscreen-background': '#030303',
    'fullscreen-accent': '#030303',

    'page-background': 'black',
    'page-foreground': 'white',

    'project-title-inactive': 'var(--ui-secondary)',
    'project-title-hover': '#ffffff3f',

    'link-color': 'var(--looks-secondary-lighter)',

    'filter-icon-black': 'invert(100%)',
    'filter-icon-gray': 'grayscale(100%) brightness(1.7)',
    'filter-icon-white': 'brightness(0) invert(100%)',

    'paint-filter-icon-gray': 'brightness(1.7)'
};

const blockColors = {
    insertionMarker: '#cccccc',
    workspace: '#080808',
    toolboxSelected: '#080808',
    toolboxText: '#cccccc',
    toolbox: '#030303',
    flyout: '#030303',
    scrollbar: '#666666',
    valueReportBackground: '#080808',
    valueReportBorder: '#111111',
    valueReportForeground: '#eeeeee',
    contextMenuBackground: '#030303',
    contextMenuBorder: '#ffffff26',
    contextMenuForeground: '#eeeeee',
    contextMenuActiveBackground: '#080808',
    contextMenuDisabledForeground: '#666666',
    flyoutLabelColor: '#cccccc',
    checkboxInactiveBackground: '#222222',
    checkboxInactiveBorder: '#c8c8c8',
    buttonBorder: '#c6c6c6',
    buttonActiveBackground: '#222222',
    buttonForeground: '#cccccc',
    zoomIconFilter: 'invert(100%)',
    gridColor: 'transparent'
};

export {
    guiColors,
    blockColors
};
